// removed by extract-text-webpack-plugin
module.exports = {"list-item-category":"list-item-category","list-item-title":"list-item-title","item-category":"item-category","item-link":"item-link"};


//////////////////
// WEBPACK FOOTER
// ./components/category/_SubCategoryMenu.scss
// module id = ./components/category/_SubCategoryMenu.scss
// module chunks = 0